export default [
  {
    action: `manage`,
    subject: `all`,
  },
];
